import { IResult } from '../types/IResponse';
import { TagRequest } from './TagRequest';

import { IAnalyticsExtConnectionSettings } from '../../../settings/types/ISiteSettingsForSiteAdmin';
import { IGetItemsResult } from '../types/IGetItemsResult';

export interface IGetAnalyticsExtConnectionSettingsResult extends IGetItemsResult {
  connectionList: IAnalyticsExtConnectionSettings[];
}

export class GetAnalyticsExtConnectionSettingsRequest extends TagRequest<{}, IGetAnalyticsExtConnectionSettingsResult> {
  constructor() {
    super('analyticsextensions', 'getAnalyticsExtensionsConnections', {});
  }
}
